export default {
    company: null,
    promise: null,
}